import { useCallback, useState } from "react";
import Cropper from "react-easy-crop";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { Slider } from "../../components/ui/slider";

async function getCroppedBlob(imageSrc, cropPixels) {
  const img = await new Promise((res, rej) => {
    const i = new window.Image();
    i.onload = () => res(i);
    i.onerror = rej;
    i.src = imageSrc;
  });
  const canvas = document.createElement("canvas");
  canvas.width = cropPixels.width;
  canvas.height = cropPixels.height;
  canvas.getContext("2d").drawImage(img, cropPixels.x, cropPixels.y, cropPixels.width, cropPixels.height, 0, 0, cropPixels.width, cropPixels.height);
  return new Promise((res) => canvas.toBlob(res, "image/jpeg", 0.92));
}

export default function CropDialog({ open, imageSrc, onCancel, onCropped }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [pixels, setPixels] = useState(null);
  const [busy, setBusy] = useState(false);

  const onComplete = useCallback((_, croppedPixels) => setPixels(croppedPixels), []);

  const confirm = async () => {
    if (!pixels) return;
    setBusy(true);
    const blob = await getCroppedBlob(imageSrc, pixels);
    setBusy(false);
    onCropped(blob);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onCancel()}>
      <DialogContent className="max-w-2xl" data-testid="crop-dialog">
        <DialogHeader>
          <DialogTitle>Crop image</DialogTitle>
        </DialogHeader>
        <div className="relative h-96 bg-slate-900 rounded-lg overflow-hidden">
          {imageSrc && (
            <Cropper image={imageSrc} crop={crop} zoom={zoom} aspect={undefined} onCropChange={setCrop} onZoomChange={setZoom} onCropComplete={onComplete} />
          )}
        </div>
        <div className="flex items-center gap-3">
          <span className="text-xs text-muted-foreground w-12">Zoom</span>
          <Slider value={[zoom]} min={1} max={4} step={0.05} onValueChange={([v]) => setZoom(v)} className="flex-1" />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} data-testid="crop-cancel">Skip crop</Button>
          <Button onClick={confirm} disabled={busy} data-testid="crop-confirm">{busy ? "Cropping…" : "Apply crop"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
